export default __webpack_public_path__ + "static/media/DSC_6122-min.22a67d12.JPG";